import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import { FiEdit, FiTrash2, FiPlus } from 'react-icons/fi';
import api from '../../api/axios';

const MesasView = () => {
  const [mesas, setMesas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({
    name: '',
    status: 'libre',
    mozo_id: '',
    comensales: '',
    plano_id:1,
  });

  const business = JSON.parse(localStorage.getItem('business'));
  const businessId = business?.id;

  useEffect(() => {
    fetchMesas();
    fetchMozos();
  }, [businessId]);

  const fetchMesas = async () => {
    try {
      const res = await api.get(`/mesas?business_id=${businessId}`);
      setMesas(res.data);
    } catch (err) {
      console.error('Error al obtener mesas:', err);
    }
  };

  const fetchMozos = async () => {
    try {
      const res = await api.get(`/users/staff?business_id=${businessId}`);
      setUsuarios(res.data.filter(u => u.role === 'mozo'));
    } catch (err) {
      console.error('Error al obtener mozos:', err);
    }
  };

  const resetForm = () => {
    setForm({ name: '', status: 'libre', mozo_id: '', comensales: '',  plano_id: 1
 });
    setEditingId(null);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

/*   const handleSubmit = async e => {
    e.preventDefault();
    try {
      if (editingId) {
        await api.put(`/tables/${editingId}`, form);
      } else {
        await api.post('/tables', { ...form, business_id: businessId });
      }
      fetchMesas();
      setShowModal(false);
      resetForm();
    } catch (err) {
      console.error('Error al guardar mesa:', err);
    }
  }; */

 const handleSubmit = async e => {
  e.preventDefault();

  try {
    const comensales = parseInt(form.comensales, 10) || 0;
    let shape = 'rectangle';

    if (comensales <= 2) shape = 'circle';
    else if (comensales === 4) shape = 'square';

    const mesaData = {
      name: form.name,
      status: form.status,
      mozo_id: form.mozo_id || null,
      comensales,
      shape,
      business_id: businessId,
      pos_x: 100,
      pos_y: 100,
        plano_id: form.plano_id

    };

    if (editingId) {
      await api.put(`/tables/${editingId}`, mesaData);
    } else {
      await api.post('/tables', mesaData);
    }

    fetchMesas();
    setShowModal(false);
    resetForm();
  } catch (err) {
    console.error('Error al guardar mesa:', err);
  }
};
 
  const handleEdit = mesa => {
    setForm({
      name: mesa.name,
      status: mesa.status,
      mozo_id: mesa.mozo_id || '',
      comensales: mesa.comensales || ''
    });
    setEditingId(mesa.id);
    setShowModal(true);
  };

  const handleDelete = async id => {
    if (!window.confirm('¿Estás seguro de eliminar esta mesa?')) return;
    try {
      await api.delete(`/tables/${id}`);
      fetchMesas();
    } catch (err) {
      console.error('Error al eliminar mesa:', err);
    }
  };

  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">🪑 Mesas del Local</h4>
        <Button variant="success" onClick={() => { resetForm(); setShowModal(true); }}>
          <FiPlus className="me-2" /> Nueva Mesa
        </Button>
      </div>

      <Table striped bordered hover responsive>
        <thead className="table-light">
          <tr>
            <th>Nombre</th>
            <th>Estado</th>
            <th>Mozo asignado</th>
            <th>Comensales</th>
            <th>Plano</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {mesas.map(mesa => (
            <tr key={mesa.id}>
              <td>{mesa.name}</td>
              <td>{mesa.status}</td>
              <td>{mesa.mozo_nombre || '—'}</td>
              <td>{mesa.comensales || 0}</td>
              <td>{mesa.plano_id || 1}</td>

              <td>
                <Button size="sm" variant="outline-warning" className="me-2" onClick={() => handleEdit(mesa)}>
                  <FiEdit className="me-1" /> Editar
                </Button>
                <Button size="sm" variant="outline-danger" onClick={() => handleDelete(mesa.id)}>
                  <FiTrash2 className="me-1" /> Eliminar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? 'Editar mesa' : 'Nueva mesa'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nombre</Form.Label>
              <Form.Control name="name" value={form.name} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Estado</Form.Label>
              <Form.Select name="status" value={form.status} onChange={handleChange}>
                <option value="libre">Libre</option>
                <option value="ocupada">Ocupada</option>
                <option value="en_espera">En espera</option>
                <option value="abonada">Abonada</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mozo asignado</Form.Label>
              <Form.Select name="mozo_id" value={form.mozo_id} onChange={handleChange}>
                <option value="">—</option>
                {usuarios.map(m => (
                  <option key={m.id} value={m.id}>{m.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Comensales</Form.Label>
              <Form.Control name="comensales" value={form.comensales} onChange={handleChange} type="number" />
            </Form.Group>

<Form.Group className="mb-3">
  <Form.Label>Plano</Form.Label>
  <Form.Select name="plano_id" value={form.plano_id} onChange={handleChange}>
    <option value={1}>Plano 1</option>
    <option value={2}>Plano 2</option>
    <option value={3}>Plano 3</option>
  </Form.Select>
</Form.Group>
            <Button type="submit" variant="success">
              {editingId ? 'Actualizar' : 'Guardar'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MesasView;
